module.exports = "/_next/static/images/PaidSubscriptionAcquisitionMobile-fbf5538932c79c15d00eb128546b28dd.png";